import { render } from "./SelectOther.vue?vue&type=template&id=65c0cd9c&scoped=true"
import script from "./SelectOther.vue?vue&type=script&lang=js"
export * from "./SelectOther.vue?vue&type=script&lang=js"

import "./SelectOther.vue?vue&type=style&index=0&id=65c0cd9c&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c0cd9c"]])

export default __exports__